import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { SeverityLevel } from '@shared/modules/severity-levels/severity-levels';
import { SEVERITY_LEVEL_COLOURS } from '@shared/modules/severity-levels/severity-levels';

@Pipe({
    name: 'severityLevelColour'
})
export class SeverityLevelColourPipe implements PipeTransform {

    transform(value: SeverityLevel): string {
        return SEVERITY_LEVEL_COLOURS[value] ?? null;
    }

}
